import {
  Container,
  ProductsCarousel,
  MenuItemsCarousel,
} from "@peracto/peracto-blocks-tailwind";

// Accordion comes from peracto-content, not peracto-blocks-tailwind: only the
// peracto-content build supplies Controls (AccordionForm), which is what makes
// the items editable in admin. isTailwind picks the storefront's renderer.
import { accordionPlugin } from "@peracto/peracto-content/dist/Editor/ContentBlocks";

import EventsCarousel from "./EventsCarousel";
import EventFinder from "./EventFinder";
import Carousel from "./Carousel"

const Accordion = accordionPlugin({ isTailwind: true });

export default {
  plugins: {
    content: [
      Carousel,
      Accordion,
      ProductsCarousel,
      MenuItemsCarousel,
      EventsCarousel,
      EventFinder
    ],
    layout: [Container],
  },
};
